const audioNotif = new Audio('/notification.mp3')
function audioCallback() {
  audioNotif.pause()
  audioNotif.currentTime = 0
  audioNotif.play()
  audioNotif.onended = () => audioNotif.play()
}
const notifications = []
export const notify = ({
  title = 'Nueva notificación',
  message = 'Nueva notificación disponible',
} = {}) => {
  if ('Notification' in window && notifications.length === 0) {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        // eslint-disable-next-line no-new
        const newNotif = new Notification(title, { body: message })
        notifications.push(newNotif)
        newNotif.onclose = () => {
          notifications.length = 0
        }
      }
    })
  }
  audioCallback()
  return () => {
    audioNotif.onended = () => {}
    notifications.forEach((n) => n.close())
    notifications.length = 0
  }
}
